import BaseService from '../baseServices';
import REST from '../../configs/rest';

function postFiles({ body }) {
  return BaseService.post(REST.UPLOAD, body);
}

function getFiles({ file }) {
  const query = {
    file,
  };
  return BaseService.get(REST.IMAGES, { params: query });
}

export default {
  postFiles,
  getFiles,
};
